module.exports = __webpack_public_path__ + "img/progress-bar-step-1.b755217.png";